import {
  SchoolConfigurationLayoutUpdateInput,
  useUpdateCommunityLayoutMutation,
} from 'shared/graphql';

export function useSchoolConfigurationLayoutUpdate() {
  const [schoolConfigurationLayoutUpdateMutation, options] = useUpdateCommunityLayoutMutation({
    refetchQueries: ['CurrentCommunity'],
    context: {
      // Override the batching rule for the operation
      // This operation is meant to be executed with multiple updates
      batch: true,
    },
  });

  const update = async (variables: SchoolConfigurationLayoutUpdateInput) => {
    await schoolConfigurationLayoutUpdateMutation({
      variables: { data: variables },
    });
  };

  return [update, options] as const;
}
